import styled, { css } from 'styled-components/macro'
import { transparentize } from 'polished'

import { Href } from 'components/ui'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`

export const LabelTitle = styled.label`
  margin: 0;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 0.6rem;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.5;
  color: ${(props) => props.theme.color.textThird};
`

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`

export const LabelContent = styled.span`
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.5;
  text-align: center;
  color: ${(props) => props.theme.color.text};
  transition: all 0.26s ease;
`

export const ContainerLabel = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.6rem;
`

export const Radio = styled.input`
  position: static;
  display: none;
`

export const ItemLabel = styled.label<{ isActive?: boolean }>`
  position: relative;
  margin: 0;
  padding: 1rem 1.6rem 1rem 1.2rem;
  width: 100%;
  max-width: 18rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  border: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  border-radius: 1.6rem;
  transition: all 0.26s ease;
  cursor: pointer;
  &:hover:not([disabled]),
  &:focus:not([disabled]),
  &:active:not([disabled]) {
    background-color: ${(props) => transparentize(0.95, props.theme.color.textHintSecond)};
    box-shadow: 0 0 0 0.3rem ${(props) => transparentize(0.5, props.theme.color.textHintSecond)};
  }
  ${(props) =>
    props.isActive &&
    css`
      background-color: ${(props) => transparentize(0.95, props.theme.color.textHintSecond)};
      border-color: ${(props) => props.theme.color.textHintSecond};
      box-shadow: 0 0 0 0.3rem ${(props) => transparentize(0.5, props.theme.color.textHintSecond)};
    `}
`

export const ItemIcon = styled.span`
  width: 3.6rem;
  height: 3.6rem;
`

export const ItemTooltip = styled.span`
  position: absolute;
  top: 0.6rem;
  right: 0.8rem;
  width: 1.6rem;
  height: 1.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.2rem;
  border: 0.1rem solid ${(props) => props.theme.textThird};
  border-radius: 50%;
`

export const HightlightText = styled.span<{ type?: string }>`
  color: ${(props) => props.theme.color.text};
  ${(props) =>
    props.type === 'green' &&
    css`
      color: ${(props) => props.theme.color.success};
    `}
  ${(props) =>
    props.type === 'orange' &&
    css`
      color: ${(props) => props.theme.color.warning};
    `}
`

export const ItemContent = styled.div`
  margin: 0;
  padding: 1.6rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.5;
  color: ${(props) => props.theme.color.textThird};
  border: 0.1rem solid ${(props) => props.theme.color.textHintSecond};
  border-radius: 1.6rem;
`

export const ItemContentText = styled.p`
  margin: 0;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.5;
  color: ${(props) => props.theme.color.textThird};
`

export const ItemContentList = styled.ol`
  margin: 0;
  padding: 0 0 0 3rem;
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
`

export const ItemContentListItem = styled.li`
  margin: 0;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.5;
  color: ${(props) => props.theme.color.text};
  &::marker {
    color: ${(props) => props.theme.color.textHintSecond};
  }
`

export const StyledLink = styled(Href)`
  padding: 1.2rem;
  display: inline-flex;
  justify-content: space-between;
  gap: 0.8rem;
  width: 100%;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.4rem;
  line-height: 1.43;
  text-align: left;
  letter-spacing: -0.03rem;
  color: ${(props) => props.theme.color.text};
  background-color: ${(props) => props.theme.color.buttonBgThird};
  border: 0.1rem solid;
  border-color: ${(props) => props.theme.color.buttonBgThird};
  border-radius: 0.8rem;
  transition: all 0.26s ease;
  &:disabled {
    opacity: ${(props) => props.theme.opacity.opacity05};
  }
  &:hover:not([disabled]),
  &:focus:not([disabled]),
  &:active:not([disabled]) {
    box-shadow: 0 0 0 0.3rem ${(props) => transparentize(0.5, props.theme.color.buttonBgThird)};
  }
`

export const Box = styled.label`
  margin: 0;
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 1.6rem;
  border: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  border-radius: 0.8rem;
  transition: all 0.26s ease;
  cursor: pointer;
  &:hover:not([disabled]),
  &:focus:not([disabled]),
  &:active:not([disabled]) {
    background-color: ${(props) => transparentize(0.95, props.theme.color.textHintSecond)};
    box-shadow: 0 0 0 0.3rem ${(props) => transparentize(0.5, props.theme.color.textHintSecond)};
  }
`

export const ButtonsWrap = styled.div`
  margin: 0 auto;
  padding: 0;
  width: 100%;
  max-width: 28.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const IconWrap = styled.div`
  margin: 0 0 1.6rem;
`

export const LoaderWrap = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  padding: 1.6rem;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: radial-gradient(rgba(0, 0, 0, 0) 0.2rem, ${(props) => props.theme.color.white} 0.2rem);
  background-size: 0.4rem 0.4rem;
  background-repeat: repeat;
  backdrop-filter: brightness(100%) blur(0.3rem);
  z-index: ${(props) => props.theme.zIndex.overlay};
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    padding: 3.2rem;
  `};
`

export const LoaderContainer = styled.div`
  position: relative;
  padding: 2.4rem;
  width: 32rem;
  height: auto;
  max-height: calc(100vh - 3.2rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3.2rem;
  background-color: ${(props) => props.theme.color.elementBg};
  border: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  border-radius: 0.8rem;
  transition: all 0.3s ease-in;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: ${(props) => props.theme.zIndex.modalContainer};
`

export const LoaderText = styled.p`
  margin: 0;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.5;
  text-align: center;
  color: ${(props) => props.theme.color.textThird};
`
